import React, { FC, Dispatch, SetStateAction, useState, useEffect } from 'react';
import { Modal, Dimmer, Loader, Button } from 'semantic-ui-react';

import { putMessage } from '../../../services/Messages';
import { toast } from 'react-toastify';

import './style.less';

interface Props {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    message: string;
    residentId: string;
    messageId: string;
    getPreviousMessages: () => any;
}

const ModalComponent: FC<Props> = props => {
    const [message, setMessage] = useState<string>(props.message);
    const [loading, setLoading] = useState<boolean>(false);
    const submitEditMessage = () => {
        setLoading(true);
        putMessage(props.residentId, props.messageId, message)
            .then(res => {
                if (res) {
                    setMessage(res.text);
                    props.getPreviousMessages();
                    toast.success('Message successfully updated', {
                        position: 'bottom-center',
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                    });
                }
                setLoading(false);
                props.setOpen(false);
            })
            .catch(error => {
                setLoading(false);
                props.setOpen(false);
                toast.error('Message could not be updated', {
                    position: 'bottom-center',
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                });
            });
    };

    useEffect(() => {
        setMessage(props.message);
    }, [props.open]);

    return (
        <Modal
            open={props.open}
            onClose={() => {
                props.setOpen(false);
            }}
            closeIcon
            size={'small'}
        >
            <div className="modal-content">
                <Dimmer active={loading} inverted>
                    <Loader active={loading} />
                </Dimmer>

                <textarea
                    name="editMessage"
                    onChange={e => setMessage(e.currentTarget.value)}
                    value={message}
                ></textarea>


                <Modal.Actions>
                    <Button className="blue submit-message" onClick={submitEditMessage} type="submit">
                        Submit
                    </Button>
                </Modal.Actions>
            </div>
        </Modal>
    );
};

export default ModalComponent;
